var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2102 2.10751C16.9924 1.63516 16.5197 1.33264 15.9995 1.33264C15.4793 1.33264 15.0066 1.63516 14.7887 2.10751L10.9633 10.401L1.89368 11.4763C1.37711 11.5376 0.943334 11.8936 0.782589 12.3884C0.621845 12.8831 0.763488 13.4261 1.1454 13.7793L7.85083 19.9803L6.07088 28.9384C5.9695 29.4486 6.17409 29.9712 6.59493 30.2769C7.01576 30.5827 7.57599 30.6158 8.0299 30.3617L15.9995 25.9006L23.9691 30.3617C24.423 30.6158 24.9832 30.5827 25.4041 30.2769C25.8249 29.9712 26.0295 29.4486 25.9281 28.9384L24.1482 19.9803L30.8536 13.7793C31.2355 13.4261 31.3771 12.8831 31.2164 12.3884C31.0557 11.8936 30.6219 11.5376 30.1053 11.4763L21.0356 10.401L17.2102 2.10751Z",
    fill: "#FFCD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.63b899836ffe78a0081ee8deca0f1329.svg";
export { ForwardRef as ReactComponent };